<template>
  <div class="bankcode">
    <div class="main">
      <div class="heard">
        绑定银行卡
      </div>
      <div class="conter">
        <el-form :model="bindCardForm" :rules="rules" ref="bindCardForm" label-width="120px" class="demo-bindCardForm" size="small">
          <el-form-item label="持卡人姓名：" prop="BankAccountName">
            <el-input v-model.trim="bindCardForm.BankAccountName" :placeholder='placeholderBankAccountName'   onkeyup="this.value=this.value.replace(/\s+/g,'')"></el-input>
            <!-- <div class="formrightbox formrightboxb">
                    <el-button class="formbtn " size="mini" v-show="show" @click="setpersonid()">绑定</el-button>
            </div>  -->
          </el-form-item>
          <el-form-item label="银行卡号：" prop="CardNO" class="phone_code">
            <el-input type="text" v-model.trim="bindCardForm.CardNO" placeholder="请输入银行卡号" onkeyup=""></el-input>
          </el-form-item>
          <el-form-item label="所属银行：" prop="BankName" class="phone_code">
            <el-select v-model="bindCardForm.BankName" class="bankname" clearable placeholder="请选择银行" style="width:100%;" @focus="GetBankName()" @change="PickBankName">
              <el-option v-for="item in banklists" :key="item.Code" :label="item.Name" :value="item.Code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="省份：" prop="ProvinceName" class="phone_code">
            <el-select v-model="bindCardForm.ProvinceName" class="provinceName" clearable placeholder="请选择所属省份" style="width:100%;" @focus="GetProvArea()" @change="PickProvCode">
              <el-option v-for="item in ProvArealists" :key="item.Code" :label="item.Name" :value="item.Code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="市/县：" prop="CityName" class="phone_code">
            <el-select v-model="bindCardForm.CityName" class="cityname" clearable placeholder="请选择所属市县" style="width:100%;" @change="PickCithCode">
              <el-option v-for="item in CityArealists" :key="item.Code" :label="item.Name" :value="item.Code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支行名称：" class="phone_code" v-if="bankTypeId!='5000'">
            <el-select v-model="bindCardForm.SubbranchName" class="subbranchname" clearable placeholder="请选择开户支行名称" style="width:100%;" @change="PickOrga">
              <el-option v-for="item in GetOrgaNamelists" :key="item.Code" :label="item.Name" :value="item.Code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支行名称："  v-if="bankTypeId=='5000'"   class="phone_code">
            <el-input  placeholder="请输入支行名称" v-model="bindCardForm.SubbranchName" clearable class="subbranchname"></el-input>
          </el-form-item>
        </el-form>



        <el-button type="primary" class="btn" @click="subSave" :disabled="disabled" style="font-size:20px">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import "../../assets/lib/jquery.min.js";
import api from "../../../static/config.json";
//import Bus from "@/assets/js/bus";
export default {
  name: "bankcode",
  data() {
    var regname = /^[0-9a-zA-Z]+$/;
    var validName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入持卡人姓名"));
      } else if (regname.test(value)) {
        callback(new Error("请输入汉字"));
      } else {
        callback();
      }
    };
    var banknumber = /^([1-9]{1})(\d{14}|\d{15}|\d{16}|\d{17}|\d{18})$/;
    var validbanknumber = (rule, value, callback) => {
      // if (value === "") {
      //   callback(new Error("请输入银行卡号"));
      // } else if (!banknumber.test(value)) {
      //   callback(new Error("请输入正确格式的银行卡号"));
      // } else {
      //   callback();
      // }
    };
    return {
      show: "",
      imgAccept: "image/jpeg,image/jpg,image/png,image/bmp",
      disabled: false,
      bindCardForm: {
        BankAccountName: "",
        BankName: "", //所选银行名称
        ProvinceName: "",
        CityName: "",
        SubbranchName: "",
        PaymNumb: "",
        CardNO: ""
      },
      usernameinfo: "",
      currAgentInfo: {},
      banklists: [], //银行名称列表
      bankTypeId: "",
      rules: {
        //验证
        // BankAccountName: [
        //   { min: 2, max: 5, message: "姓名输入有误", trigger: "blur" },
        //   {
        //     required: true,
        //     min: 2,
        //     max: 5,
        //     validator: validName,
        //     trigger: "blur"
        //   }
        // ],
        // CardNO: [
        //   { required: true, validator: validbanknumber, trigger: "blur" }
        // ]
      },
      ProvArealists: [], //省份列表
      ProvAreaCode: "",
      CityArealists: [],
      cityId: "",
      GetOrgaNamelists: [],
       insTestProp: {
        IsTestIns: true, // 是否测试机构，true测试机构
        UserRelyPhone: true, // 依赖手机号
        UseCustomId: true, // 使用自定义ID,false表示使用系统自动生成，true表示使用自定义ID
        EnabledUsdt: false,
        AllowNonRealNameUserOpenPosition: false  //允许非实名用户
      },
      placeholderBankAccountName:"",
      IsBankCode:false //是否允许绑定银行卡
    };
  },
  mounted() {
    // this.GetBankName();
    this.insTestProp = JSON.parse(sessionStorage.getItem("insTestProp"));
    if (this.insTestProp.UserRelyPhone) {
      this.getAgentInfo();
    }
    this.getuserInfo();
  },
  methods: {
    // 获取银行名称
    GetBankName() {
      let url = "/openinsuser/GetBankName/";
      this.$loginapi.post(url, "", response => {
        if (response.Ret == 0) {
          if (response.Data.length > 0) {
            this.banklists = response.Data;
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    PickBankName(value) {
      // this.bankTypeId = value;
      this.bankTypeId = value;
      this.ProvArealists = null;
      this.bindCardForm.ProvinceName = null;
      this.CityArealists = null;
      this.bindCardForm.CityName = null;
      this.GetOrgaNamelists = null;
      this.bindCardForm.SubbranchName = null;
    },
    GetProvArea() {
      let url = "/openinsuser/GetProvArea/";
      this.$loginapi.post(url, "", response => {
        if (response.Ret == 0) {
          if (response.Data.length > 0) {
            this.ProvArealists = response.Data;
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    PickProvCode(value) {
      // this.ProvAreaCode = value;
      // this.GetCityArea(value);
      this.ProvAreaCode = value;
      this.CityArealists = null;
      this.bindCardForm.CityName = null;
      this.GetOrgaNamelists = null;
      this.bindCardForm.SubbranchName = null;
      this.GetCityArea(value);
    },
    GetCityArea(value) {
      if (value == "" || value == null) {
        return;
      }
      let postData = "provId="+ value;
      let url = "/openinsuser/GetCityArea/";
      this.$indexapi.post(url, postData, response => {
        if (response.Ret == 0) {
          this.CityArealists = response.Data;
        } else {
          this.$message.error(data.Msg);
        }
      });
    },
    PickCithCode(value) {
      // this.cityId = value;
      // this.GetOrgaName(value);
      this.cityId = value;
      this.GetOrgaNamelists = null;
      this.bindCardForm.SubbranchName = null;
      this.GetOrgaName(value);
    },
    GetOrgaName(value) {
      if (value == "" || value == null) {
        return;
      }
      let url = "/openinsuser/GetOrgaName/";
      let postData =
        "bankTypeId=" +
        this.bankTypeId +
        "&provId=" +
        this.ProvAreaCode +
        "&cityId=" +
        value;
      this.$indexapi.post(url, postData, response => {
        if (response.Ret == 0) {
          this.GetOrgaNamelists = response.Data;
        } else {
          this.$message.error(data.Msg);
        }
      });
    },
    PickOrga(value) {
      this.bindCardForm.PaymNumb = value;
    },
    subSave() {
      if(!this.IsBankCode){
        this.$message.warning("账户未完成实名认证，请实名认证成功后绑定银行卡！");
        return;
      }
      this.bindCardForm.BankName = $(".bankname")
        .children(".el-input")
        .children("input")
        .val();
      this.bindCardForm.ProvinceName = $(".provinceName")
        .children(".el-input")
        .children("input")
        .val();
      this.bindCardForm.CityName = $(".cityname")
        .children(".el-input")
        .children("input")
        .val();

      if(this.bankTypeId=='5000'){

            this.bindCardForm.PaymNumb = '000000000000';
        }else{

        this.bindCardForm.SubbranchName = $(".subbranchname")
                .children(".el-input")
                .children("input")
                .val();
        }
        
        if (this.bindCardForm.BankName == "")
        {
          this.$message.error("请完整填写信息后提交！");
          return;
        }
      // for (let key in this.bindCardForm) {
      //   if (this.bindCardForm[key] == "") {
      //     this.$message.error("请完整填写信息后提交！");
      //     return;
      //   }
      // }
      this.loading = true;
      let url = "/Account/BindBankCard";
      this.$loginapi.post(url, this.bindCardForm, response => {
        if (response.Ret == 0) {
          this.$message.success(response.Msg);
          let _this = this;
          setTimeout(function() {
            _this.loading = false;
            _this.$router.push("/personaldata");
            //Bus.$emit("activeIndex4", "/personaldata");
          }, 500);
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    //删除银行卡
    UnBindBankCard() {
      let url = "/Account/UnBindBankCard";
      let postData = [];
      this.$loginapi.post(url, postData, response => {
        if (response.Ret == 0) {
          this.$message.success("银行卡已解除绑定");
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    //获取当前代理人手机号码及认证信息
    getAgentInfo() {
      let url = "/Account/GetUserInfo";
      this.$loginapi.post(
        url,
        this.$store.state.userInfo.UserCode,
        response => {
          if (response.Ret == 0) {
            this.currAgentInfo = response.Data;
            this.showBindCardPage();
          } else {
            this.$message.error(response.Msg);
          }
        }
      );
    },
    //获取当前登录用户身份证信息
    getuserInfo() {
      let infodata = {
        InsCode: this.$store.state.userInfo.InsCode,
        UserCode: this.$store.state.userInfo.UserCode,
        UserType: this.$store.state.userInfo.UserType
      };
      let url = "/RealNameAuth/IsAuthed";
      this.$loginapi.post(url, infodata, response => {
        if (response.Ret == 0) {
          if (response.Data.Result == 0) {
            // this.$alert('账户未实名认证，请先实名认证！', '', {
            // confirmButtonText: '确定',
            // callback: action => {
            //   this.$router.push("/modification/personid");
            //     return;
            // }
            // });
            //  this.showBindCardPage();
            this.IsBankCode = false;
            this.disabled = true;
            // if (this.insTestProp.AllowNonRealNameUserOpenPosition == false){
              this.$message.warning("账户未实名认证，请先实名认证！");
              this.placeholderBankAccountName = "账户未实名认证，请先实名认证！";
              
            // }
            this.show = true;
          }
          if (response.Data.Result == 1) {
            this.IsBankCode = true;
            let url = "/RealNameAuth/GetInfoForMan";
            this.$loginapi.post(url, infodata, response => {
              if (response.Ret == 0) {
                // this.usernameinfo = response.Data.RealName;
                this.IDCardNo = response.Data.IDCardNo;
                // this.bindCardForm.BankAccountName = this.usernameinfo;
              } else {
                // this.$message.error(response.Msg);
              }
            });
          }
          if (response.Data.Result == 2) {
            // this.$alert('账户正在实名认证中,请等待审核！', '', {
            // confirmButtonText: '确定',
            // callback: action => {
            //   this.$router.push("/index");
            //   Bus.$emit('activeIndex1','/index')
            //     return;
            // }
            // });
            this.IsBankCode = false;
            this.$message.warning("账户正在实名认证中,请等待审核！");
            this.disabled = true;
          }
          if (response.Data.Result == 3) {
            //   this.$alert('账户实名认证失败,请重新实名认证！', '', {
            // confirmButtonText: '确定',
            // callback: action => {
            //   this.$router.push("/modification/personid");
            //    Bus.$emit('activeIndex4','')
            //     return;
            // }
            // });
            this.IsBankCode = false;
            this.$message.warning("账户实名认证失败,请重新实名认证！");
            this.disabled = true;
            this.show = true;
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    // 验证账户绑定信息
    showBindCardPage() {
      if (
        this.currAgentInfo.BindPhone == "" ||
        this.currAgentInfo.BindPhone == null
      ) {
        this.$alert("账户未绑定手机号，请先绑定手机号！", "", {
          confirmButtonText: "确定",
          callback: action => {
            this.$router.push("/modification/phone");
            //Bus.$emit("activeIndex4", "");
            return;
          }
        });
      }
    },
    setpersonid() {
      this.$router.push("/modification/personid");
    }


  }
};
</script>

<style scoped>
.formrightbox{
    display: inline-block;
    position: absolute;
    margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/modification/bankcode.vue